class CardVariants extends HTMLElement {
    constructor() {
        super();
        this.buttons = this.querySelectorAll('button');
        this.miniCart = document.querySelector('mini-cart');
    }

    connectedCallback() {
        this.buttons.forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                console.log(event.target.dataset)
                this.addToCart(event.target.dataset.variantId, event.target);
            });
        });
    }

    showErrorMessage(errorText) {
        const miniCartFooter = document.querySelector('.mini-cart--footer');
        const cartError = document.querySelector('.cart-error') || document.createElement('div');
        cartError.classList.add('cart-error');
        cartError.textContent = errorText;
        if (miniCartFooter.firstChild) {
            miniCartFooter.insertBefore(cartError, miniCartFooter.firstChild);
        } else {
            miniCartFooter.appendChild(cartError);
        }
    }

    addToCart(variantId, button) {
        let formData = {
        'items': [{
            'id': parseInt(variantId, 10),
            'quantity': 1
            }]
        };

        button.classList.add('is-loading');

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            button.classList.remove('is-loading');
            return response.json();
        }).then(data => {
            if (data.status && data.status !== 200) {
                const message = data.description || data.message || 'An error occurred';
                this.showErrorMessage(message)
                this.miniCart.open();
            } else {
                this.miniCart.updateView(true);
            }
        })
        .catch((error) => {
            console.error('Error:', error);
            button.classList.remove('is-loading');
        });
    }

}

customElements.define('card-variants', CardVariants);